<template>
  <div>
    <a-modal v-model:visible="visible" title="查看症候群" @ok="handleOk" okText="新建" cancelText="关闭" :afterClose="closeModal" width="50vw" :okButtonProps="{ style: { display: 'none' }}">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

        <div class="detailModal">
          <div><label>名称：</label><span>{{record?.name}}</span></div>
          <div><label>首字母：</label><span>{{record?.nameInitial}}</span></div>
          <div><label>脏腑：</label><span>{{record?.zangfu}}</span></div>
          <div><label>脏腑影响：</label><span>{{record?.zangfuAffect}}</span></div>
          <div><label>性别：</label><span>{{record?.gender}}</span></div>
        </div>

        <a-table class="ant-table-striped" :columns="columns" :data-source="data" rowKey="medicineId" :pagination="false" bordered>
          <template #title>
            <div class="thead">别名列表</div>
          </template>
          <template #operation="{ record }">
            <div class="flex_sa">
              <div class="editable-row-operations">
                <span>
                  <a-popconfirm title="是否确认删除" @confirm="onDelete(record.id)" okText="确认" cancelText="取消">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
              </div>
            </div>
          </template>
        </a-table>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { Search, Update } from "/src/api/syndrome.js";

export default {
  components: {
  },
  props: {
    record: {
      type: Object,
      default: () => ({}) // 修复：对象的默认值必须是工厂函数
    },
    modelValue: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      visible: this.modelValue,
      prescription: "",
      formState: {}, // 修复：增加表单的 model 绑定对象
      columns: [
        {
          title: "名称",
          key: "name",
          dataIndex: "name",
          width: "30%",
          slots: {
            customRender: "name"
          }
        },
        {
          title: "首字母",
          key: "nameInitial",
          dataIndex: "nameInitial",
          width: "20%",
          slots: {
            customRender: "nameInitial"
          }
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "20%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],
      labelCol: {
        span: 2,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  created() {
  },
  mounted() {
  },
  activated() {
  },
  computed: {
  },
  watch: {
    record: {
      handler(val) {
        if (val && val.id) {
          this.detail();
        }
      },
      deep: true,
      immediate: true // 修复：确保首次传入 record 时也能触发查询
    },
    modelValue(val) {
      this.visible = val;
    },
  },
  methods: {
    async detail() {
      if (!this.record?.id) return;

      let res = await Search({ parentId: this.record.id });
      console.log(res);
      
      this.data = res.data?.records || [];
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    },
    async onDelete(id) {
      let res = await Update({ id, parentId: 0 });
      if (res.errCode === 0 || res.code === 200) {
        this.$message.success("删除成功");
        this.detail();
      } else {
        this.$message.error(res.errMsg || "删除失败");
      }
    },
    handleOk() {
    }
  },
};
</script>

<style scoped>
.tableStyle {
  border: 1px solid #f0f0f0;
  padding: 10px;
}
.thead {
  text-align: center;
  font-weight: bold;
  letter-spacing: 0.5em;
}
.tr {
  display: flex !important;
  flex-wrap: wrap;
  text-align: center;
  font-size: 16px;
}
.tr > div {
  width: 12.5%;
  padding: 5px 12px;
}
.detailModal {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
</style>